// Wallet login lives entirely in sdk-dapp (unlock panel → native-auth token).
// This module only keeps the projectId sanity check that the panel needs.
//
// History: a hand-rolled WalletConnect deep-link path for phone Telegram used
// to live here. It's gone with the Mini App: Telegram's Bot Developer Terms
// (7.2/7.4) forbid non-TON wallets inside Mini Apps, so the game is a website
// and Telegram is only the doorway (bot-issued login links, see App.tsx).

const PROJECT_ID = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID ?? "";

/**
 * Whether xPortal (WalletConnect) login can work at all. sdk-dapp's default
 * projectId is "" and its WalletConnect strategy throws `invalidConfig` on an
 * empty one — swallowed inside `init()`, so the panel's xPortal option becomes a
 * silent no-op (no error, no network). Surface that instead.
 */
export const WALLETCONNECT_CONFIGURED = PROJECT_ID.length > 0;
export const WALLETCONNECT_MISSING_MSG =
  "xPortal login isn't configured (missing VITE_WALLETCONNECT_PROJECT_ID) — rebuild the site with one set.";
